export function digitsOnly(value) {
  return String(value || "").replace(/\D/g, "");
}

function formatCpfPartial(digits) {
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}.${digits.slice(3)}`;
  if (digits.length <= 9) return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6)}`;
  return `${digits.slice(0, 3)}.${digits.slice(3, 6)}.${digits.slice(6, 9)}-${digits.slice(9, 11)}`;
}

function formatCnpjPartial(digits) {
  if (digits.length <= 2) return digits;
  if (digits.length <= 5) return `${digits.slice(0, 2)}.${digits.slice(2)}`;
  if (digits.length <= 8) return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5)}`;
  if (digits.length <= 12) return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8)}`;
  return `${digits.slice(0, 2)}.${digits.slice(2, 5)}.${digits.slice(5, 8)}/${digits.slice(8, 12)}-${digits.slice(12, 14)}`;
}

export function formatTaxIdInput(raw) {
  const digits = digitsOnly(raw).slice(0, 14);
  if (digits.length <= 11) return formatCpfPartial(digits);
  return formatCnpjPartial(digits);
}

export function maskCpf(digits) {
  const d = digitsOnly(digits);
  if (!d) return "";
  return `***.***.***-${d.slice(-2)}`;
}

export function formatCnpj(digits) {
  const d = digitsOnly(digits);
  if (d.length !== 14) return String(digits || "").trim();
  return `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12, 14)}`;
}

export function resolveRecipientTaxId(doc) {
  if (!doc) return null;

  if (doc.recipient_cnpj) {
    return { kind: "cnpj", value: formatCnpj(doc.recipient_cnpj) };
  }

  if (doc.recipient_cpf || doc.recipient_cpf_masked) {
    const digits = digitsOnly(doc.recipient_cpf || doc.recipient_cpf_masked);
    if (digits.length > 11) {
      return { kind: "cnpj", value: formatCnpj(digits) };
    }
    return {
      kind: "cpf",
      value: doc.recipient_cpf_masked || maskCpf(doc.recipient_cpf),
    };
  }

  if (doc.recipient_cnpj_masked) {
    const digits = digitsOnly(doc.recipient_cnpj_masked);
    return {
      kind: "cnpj",
      value: digits.length === 14 ? formatCnpj(digits) : doc.recipient_cnpj_masked,
    };
  }

  return null;
}

/** Formats Brazilian ZIP code (CEP) while typing. */
export function formatZipCodeInput(raw) {
  const digits = digitsOnly(raw).slice(0, 8);
  if (digits.length <= 5) return digits;
  return `${digits.slice(0, 5)}-${digits.slice(5)}`;
}
